import { Component, OnInit } from '@angular/core';
import { Container } from '../../models/container.model';
import { ContainerValidatorService } from '../../validators/container-validator.service';
import { ContainerService } from '../../services/container.service';
import { take, catchError } from 'rxjs/operators';
import { ContainerGrades } from '../../models/container-grades.model';
import { Grade } from '../../models/grade.model';

@Component({
    selector: 'app-containers-new',
    templateUrl: './containers-new.component.html',
    styleUrls: ['./containers-new.component.scss'],
    standalone: false
})
export class ContainersNewComponent implements OnInit {

  container: Container = new Container();

  containerGrades: any = {grades: []};

  isError: boolean = false;
  isServerError: boolean = false;

  constructor(private containerValidator: ContainerValidatorService,
    private containerService: ContainerService) { }

  ngOnInit(): void {
  }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;


    if(this.containerValidator.isValid(this.container)) {
      // try to save it
      this.containerService.createContainer(this.container)
      .pipe(take(1))
      .pipe(catchError((e) => {
        this.isServerError = true;
        return e;
      }))
      .subscribe((data: Container) => {
        if(this.containerGrades.grades.length > 0) {
          this.saveGrades(data.id);
        } else {
           // move to edit mode
        window.location.href = '/containers';
        }
      })
    } else {
      this.isError = true;
    }
  }

  saveGrades(containerId: number) {
    const containerGrades: ContainerGrades[] = [];

    this.containerGrades.grades.forEach((grade: Grade) => {
      const containerGrade = new ContainerGrades();
      containerGrade.gradeId = grade.id;
      containerGrade.containerId = containerId;

      containerGrades.push(containerGrade);
    });

    this.containerService.bulkAddContainerGrades(containerGrades)
    .pipe(take(1))
    .pipe(catchError((e) => {
      if(e.status === 403 || e.status === 401) {
        return e;
      }
      alert('Could not save grades for container');
      return e;
    }))
    .subscribe(() => {
      // move to edit mode
      window.location.href = '/containers';
    })
  }

}
